<template>
  <div class="h-auto w-full mr-3 my-3">

    <div class="bg-white mx-3 rounded-b-md mt-3">
      <el-tabs type="border-card" @tab-click="setTab">
        <el-tab-pane
          v-for="(tab, index) in tabs"
          :key="index"
          :label="tab.name"
        >
          <div class="m-3">
            <div v-if="tab.name==='360 Evaluation'" class="bg-gray-200 rounded-md mb-3">
              <div class="border-b-1 flex justify-between items-center p-4">
                <p class="text-sm font-semibold w-full">Setup</p>
              </div>
              <div class="grid grid-cols-2 p-2 px-4 gap-5">
                <div class="radio-option flex items-center" v-for="option in options" :key="option" >
                  <input
                      type="radio"
                      :value="option.name"
                      v-model="selectedOption"
                  />
                  <label class="ml-2">{{ option.title }}</label>
                </div>
              </div>
              <div class="grid grid-cols-1 flex justify-items-end  pb-5 px-4">
                <button
                    class="border-1.5 rounded-full px-2 py-1 items-center gap-1 bg-primaryDark hover:bg-primary hover:text-gray-200 text-white border-primary flex capitalize"
                    @click="updateSetting"
                    :disabled="loading"
                >
                  {{ loading ? "Updating..." : "Update" }}
                </button>
              </div>
            </div>
          </div>

          <div class="border-b-0.5 flex justify-between items-center p-2">
            <p class="text-sm font-semibold w-full">List of {{ tab.name }} </p>
          </div>

          <div>
            <component :is="tab.component" isCurrent="isCurrent"></component>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <action-warning
      :message="message"
      :set-is-confirmed="setIsConfirmed"
      :show-warning="showWarning"
      @close="showWarning = false"
      :title="title"
    ></action-warning>
  </div>
</template>

<script>
import Loader from "@/components/loader/loader.vue";
import ActionWarning from "../../../utils/actionWarning.vue";
import ReviewPeriodsList from "./reviewPeriods/ReviewPeriodsList.vue";
import StrategicGoalsList from "./strategicGoals/StrategicGoalsList.vue";
import StrategicOutcomeList from "./strategicOutcome/StrategicOutcomeList.vue";
import StrategicValuesList from "./strategicValue/StrategicValuesList.vue";
import StrategicQuestionList from "./strategicQuestion/StrategicQuestionList.vue";
import EvaluationQuestions from "./360Evaluation/360EvaluationQuestions";
import RecommendationTypes from "./Recommendations/recommendations"
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "PerformanceSetups",
  components: {
    Loader,
    ActionWarning,
    ReviewPeriodsList,
    StrategicGoalsList,
    StrategicOutcomeList,
    StrategicValuesList,
    StrategicQuestionList,
    EvaluationQuestions,
    RecommendationTypes
  },
  data() {
    return {
      currentTab: "Review Periods",
      tabs: [
        {
          name: "Review Periods",
          route: "performance-periods",
          component: "ReviewPeriodsList",
        },
        {
          name: "Strategic Goals",
          route: "strategic-goals",
          component: "StrategicGoalsList",
        },
        {
          name: "Strategic Outcomes",
          route: "strategic-outcomes",
          component: "StrategicOutcomeList",
        },
        {
          name: "Strategic Values",
          route: "strategic-values",
          component: "StrategicValuesList",
        },
        {
          name: "Strategic Questions",
          route: "strategic-questions",
          component: "StrategicQuestionList",
        },
        {
          name: "360 Evaluation",
          route: "360-evaluation",
          component: "EvaluationQuestions",
        },
        {
          name: "Recommendations",
          route: "recommendation",
          component: "RecommendationTypes",
        },
      ],
      selectedOption: '',
      options:[
        {
          title:'Allow employess to request for feedback',
          name:'RequestFeedback'
        },
        {
          title:'Allow employess to choose who to give feedback to',
          name:'GiveFeedback'
        }
      ],
      title: "Performance Setups",
      performanceSetups: [],
      resultColumns: [],
      showEditPerformance: false,
      showCreatePerformanceSetup: false,
      loading: false,

      info: null,
      message: null,
      showWarning: false,
      setIsConfirmed: false,
      tableData: [],
      isCurrent: false,
    };
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  created() {
    this.getFeedbackSetting()
  },
  methods: {
    async updateSetting() {
      this.loading = true;
      const payload = {
        GiveFeedback: this.selectedOption === "GiveFeedback",
        RequestFeedback: this.selectedOption === "RequestFeedback",
      };
      try {
        const response = await axios.put(
            `${this.getOrganization}/performance/360evaluation/setup/${this.$ApiVersion}/edit`,
            payload,
            {
              headers: {
                Authorization: `Bearer ${this.getToken}`,
              },
            }
        );

        if (response.status === 200) {
          this.$notify({
            title: "Success",
            message: "Feedback setting updated successfully.",
            type: "success",
          });
        } else {
          throw new Error(response.data.message || "Failed to update setting.");
        }
      } catch (error) {
        this.$notify.error({
          title: "Error",
          message: error.message || "An error occurred while updating.",
        });
      } finally {
        this.loading = false;
      }
    },
    getFeedbackSetting(){
      this.loading = true;
      let url = `${this.getOrganization}/performance/360evaluation/setup/${this.$ApiVersion}/request`;

      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios.get(url, options).then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode === 200) {
              if (response.data.Data.RequestFeedback) {
                this.selectedOption = "RequestFeedback";
              } else if (response.data.Data.GiveFeedback) {
                this.selectedOption = "GiveFeedback";
              }
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
      );
    },
    setTab() {
      switch (this.currentTab) {
        case "Review Periods":
          this.isCurrent = true;
          break;
        case "Strategic Goals":
          this.isCurrent = true;
          break;
        case "Strategic Outcomes":
          this.isCurrent = true;
          break;
        case "Strategic Values":
          this.isCurrent = true;
          break;
        case "Strategic Questions":
          this.isCurrent = true;
          break;
        case "360 Evaluation":
          this.isCurrent = true;
          break;
        default:
          return null;
      }
    },
    reload() {
      this.showEditPerformance = false;
      this.showCreatePerformanceSetup = false;

      setTimeout(() => {
        this.showAssetBulkUpload = false;
      }, 3000);
    },
    close() {
      this.showBulkUpload = false;
      this.$emit("close");
    },
  },


};
</script>

<style>
.ve-table-body-td {
  z-index: -2;
}
</style>
